import React, { useContext } from "react";
import { IconButton } from "@mui/material";
import { SectionIndicatorContext } from "../shared/contexts/SectionIndicatorContext";
import { DefaultValues, FieldValues, KeepStateOptions } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import ArrowLeftIcon from "./Icons/ArrowLeft";
import { getExternalUrls } from "../configuration/config-external-urls";

interface ArrowBackButtonProps {
	reset?: (values?: DefaultValues<FieldValues> | FieldValues, keepStateOptions?: KeepStateOptions) => void;
}

export const ArrowBackButton = ({ reset }: ArrowBackButtonProps): JSX.Element => {
	const { setSectionNumber, sectionNumber } = useContext(SectionIndicatorContext);

	const navigate = useNavigate();

	function handleButtonClick(): void {
		switch (sectionNumber) {
			case 0:
				window.location.href = getExternalUrls().BACK_TO_SOURCE || "";
				break;
			case 2:
				setSectionNumber(1);
				break;
			default:
				navigate(process.env.PUBLIC_URL || "/")
		}
	}

	return (
		<IconButton edge="start" color="primary" onClick={() => handleButtonClick()}>
			<ArrowLeftIcon />
		</IconButton>
	);
};
